import { FC, useRef } from "react";
import { useEffect, useState } from "react";
import Modal from "react-modal";
import { useNavigate, useParams } from "react-router-dom";

import { Loading } from "../Loading";
import styles from './index.module.css';
import { Input } from "../Input/Input";
import Swal from "sweetalert2";
import { VendorCart } from "../../contexts/FiltersContext";
import { useFilters } from "../../hooks/useFilters";
import { MainButton } from "../MainButton";

type Props = {
    setOpenModalFiltroOrder: (open: boolean) => void;
    openModalFiltroOrder: boolean;
    config: any
}

type Options = {
    select: string
    value: string
}


const ModalFiltroPedidoVendedor: FC<Props> = ({ setOpenModalFiltroOrder, openModalFiltroOrder, config }) => {
    const refDiv = useRef<HTMLDivElement>(null)
    const navigate = useNavigate()
    const { pluginspace_id } = useParams();

    const { setVendorCart } = useFilters();

    const [loading, setLoading] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    const [filterOptions, setFilterOptions] = useState<VendorCart>({
        initAt: '',
        finishAt: '',
        order: '',
        cpfCustomer: '',
        status: [],
    })
    function handleCloseModal() {
        setIsAnimating(true); // Inicia a animação de fechamento
        setOpenModalFiltroOrder(false); // Fecha o modal
    }
    function handleFilterOptionsChange(newOptions: VendorCart) {
        setFilterOptions(newOptions);
        setVendorCart(newOptions)
    }
    const [options, setOptions] = useState<Options[]>([
        { select: 'Pendente', value: 'open' },
        { select: 'Pago', value: 'used' },
        { select: 'Cancelado', value: 'canceled' },
    ]);

    function clearFilter() {


        const filterCleared = {
            initAt: '',
            finishAt: '',
            order: filterOptions.order,
            cpfCustomer: filterOptions.cpfCustomer,
            status: [],
        }
        setFilterOptions(filterCleared);
        setVendorCart(filterCleared)
        navigate(`/${pluginspace_id}/sellerOrder?refresh=${new Date().getTime()}`, { replace: true });
        setOpenModalFiltroOrder(false)
    }
    const setFilter = () => {
        setFilterOptions(filterOptions);
        setVendorCart(filterOptions);
        navigate(`/${pluginspace_id}/sellerOrder?refresh=${new Date().getTime()}`, { replace: true });
        setOpenModalFiltroOrder(false)
    }

    return (
        <>
            {(openModalFiltroOrder || isAnimating) && (
                <div
                    className={`
                        ${styles.modalFiltro__overlay}
                        ${openModalFiltroOrder ? styles.modalFiltro__fadeInUp : styles.modalFiltro__fadeOutDown}
                    `}
                    onAnimationEnd={() => {
                        if (!openModalFiltroOrder) setIsAnimating(false); // Remove do DOM após a animação de fechamento
                    }}
                >
                    <div className={styles.modalFiltro__closeArea} onClick={handleCloseModal}></div>

                    <div className={styles.modalFiltro__container}>
                        {loading ? (
                            <div className={styles.modalFiltro__loading}>
                                <Loading
                                    type="spinningBubbles"
                                    color="#FFF"
                                    width={64}
                                    height={64}
                                />
                            </div>
                        ) : (
                            <div className={styles.modalFiltro__contentWrapper}>
                                <div className={styles.modalFiltro__header}>
                                    <button className={styles.modalFiltro__header_close} onClick={handleCloseModal}>
                                        <svg
                                            width="28"
                                            height="28"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M8 8L16 16"
                                                stroke="#000"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                            />
                                            <path
                                                d="M16 8L8 16"
                                                stroke="#000"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                    </button>
                                </div>
                                <div
                                    className={styles.modalFiltro__content}
                                    ref={refDiv}
                                    onClick={(e) => e.stopPropagation()} // Prevent click propagation
                                >
                                    <div className={styles.grow}>
                                        {options.length > 0 && (
                                            <div className={styles.modalFiltro__statusSection}>
                                                <span>Status</span>
                                                <div className={styles.modalFiltro__statusList}>
                                                    {options.map((item, index) => (
                                                        <div key={index} className={styles.modalFiltro__statusItem}>
                                                            <Input
                                                                placeholder={item.select}
                                                                label={item.select}
                                                                name="dataInitial"
                                                                checked={filterOptions.status.includes(item.value)}
                                                                inputAttr={{ type: "checkbox_modal_vendedor" }}
                                                                change={() => {
                                                                    const newStatus = filterOptions.status.includes(item.value)
                                                                        ? filterOptions.status.filter((id: String) => id !== item.value)
                                                                        : [...filterOptions.status, item.value];
                                                                    handleFilterOptionsChange({ ...filterOptions, status: newStatus });
                                                                }}
                                                                backgroundColor="#fff"
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        <div className={styles.modalFiltro__dateRow}>
                                            <div className={styles.modalFiltro__dateCol}>
                                                <span>De</span>
                                                <Input
                                                    placeholder="Data Inicial"
                                                    name="dataInitial"
                                                    value={filterOptions.initAt}
                                                    inputAttr={{ type: "date_modal_vendedor" }}
                                                    change={(value: string) => {
                                                        setFilterOptions({ ...filterOptions, initAt: value });
                                                    }}
                                                    backgroundColor="#FFF"
                                                />
                                            </div>
                                            <div className={styles.modalFiltro__dateCol}>
                                                <span>Até</span>
                                                <Input
                                                    placeholder="Data Final"
                                                    name="dataFinal"
                                                    value={filterOptions.finishAt}
                                                    inputAttr={{ type: "date_modal_vendedor" }}
                                                    change={(value: string) => {
                                                        setFilterOptions({ ...filterOptions, finishAt: value });
                                                    }}
                                                    backgroundColor="#FFF"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.modalFiltro__footer}>
                                        <MainButton
                                            color={
                                                config?.webappcolor.fontbutton
                                                    ? config.webappcolor.fontbutton
                                                    : "#636363"
                                            }
                                            backgroundColor={
                                                config?.webappcolor.webappbutton
                                                    ? config.webappcolor.webappbutton
                                                    : "#EAEAEA"
                                            }
                                            text="Limpar Filtro"
                                            onClick={clearFilter}
                                        />

                                        <MainButton
                                            color={
                                                config?.webappcolor.fontbutton
                                                    ? config.webappcolor.fontbutton
                                                    : "#636363"
                                            }
                                            backgroundColor={
                                                config?.webappcolor.webappbutton
                                                    ? config.webappcolor.webappbutton
                                                    : "#EAEAEA"
                                            }
                                            text="Filtrar"
                                            onClick={setFilter}
                                        />
                                        {/*
                                        <AccessButton
                                            text={'Limpar Filtro'}
                                            onClick={clearFilter}
                                            outLine={true}
                                            growth={true}
                                        />
                                        <AccessButton
                                            text={'Filtrar'}
                                            onClick={setFilter}
                                            growth={true} />
                                        */}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    )
}

export { ModalFiltroPedidoVendedor }